import _objectSpread from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
export var createVideoFrame = function createVideoFrame(emitNotSupportedError, wrapSubscribeFunction) {
  return function (videoElement) {
    return wrapSubscribeFunction(function (observer) {
      if (videoElement.cancelVideoFrameCallback === undefined || videoElement.requestVideoFrameCallback === undefined) {
        return emitNotSupportedError(observer);
      }
      var videoFrameHandle = videoElement.requestVideoFrameCallback(function videoFrameCallback(now, metadata) {
        videoFrameHandle = videoElement.requestVideoFrameCallback(videoFrameCallback);
        observer.next(_objectSpread(_objectSpread({}, metadata), {}, {
          now: now
        }));
      });
      return function () {
        return videoElement.cancelVideoFrameCallback(videoFrameHandle);
      };
    });
  };
};